import { post } from "@/api/index";
import request from "@/utils/request";

const pre = "/dapi/b-access-layer/v1/access/";

/**
 * 话术库分组
 */
export const getALLGroupList = (params) => {
  return post(pre + "knowledge-config-center/v1/group/list", params);
};

/**
 * 话术库分组
 */
export const getGroupList = (params) => {
  return post(pre + "knowledge-config-center/v1/group/groupList", params);
};

/**
 * 话术库数据
 */
export const getGroupDetail = (params) => {
  return post(
    pre +
      "knowledge-chatstratage-management/v1/content/chatStratage/list2C/standard",
    params
  );
};

// 话术库标签列表
export function groupListApi(data) {
  return request({
    url: "/dapi/b-access-layer/v1/access/knowledge-config-center/v1/group/list",
    method: "post",
    data,
  });
}

// 话术库列表
export function groupStandardApi(data) {
  return request({
    url:
      "/dapi/b-access-layer/v1/access/knowledge-chatstratage-management/v1/content/chatStratage/list2C/standard",
    method: "post",
    data,
  });
}

const base = "/dapi/b-access-layer/v1/access/knowledge-chatstratage-management";
// 查询个人话术列表
export function personalListApi(data) {
  return request({
    url: `${base}/v1/client/chat/list/personal`,
    method: "post",
    data,
  });
}

// 创建个人话术
export function addPersonalApi(data) {
  return request({
    url: `${base}/v1/content/chatStratage/add/personal`,
    method: "post",
    data,
  });
}

// 修改个人话术
export function updatePersonalApi(data) {
  return request({
    url: `${base}/v1/client/chat/update/personal`,
    method: "post",
    data,
  });
}

/**
 * 查询话术标签
 */
export function tagGroupListApi(data) {
  return request({
    url: `/dapi/b-access-layer/v1/access/knowledge-label-service/v1/tagGroup/list`,
    method: "post",
    data,
  });
}

/**
 * 删除个人话术
 */
export function delPersonalApi(data) {
  return request({
    url: `${base}/v1/client/chat/del/personal`,
    method: "post",
    data,
  });
}
